import Vue from "vue";
import App from "./App.vue";
import PrismicVue from "@prismicio/vue";
import router from "./router";
import { DefaultRequestHandler } from "./handlers/prismicRequestHandler";
import "./assets/scss/app.scss";

// Habilitar Vue DevTools en desarrollo
Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = false;

const prismicEndpoint = `${process.env.VUE_APP_CDN_API_BASE_PATH}/v1/content/prismic`;
var requestHandler = new DefaultRequestHandler();

Vue.use(PrismicVue, {
  endpoint: prismicEndpoint,
  apiOptions: { requestHandler },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
